import MyRequest from "features/myDocument/pages/MyRequest";

function EmployeeDocument() {
  return <MyRequest isEmployee={true} />;
}

export default EmployeeDocument;
